import { render, staticRenderFns } from "./CPHphCartDisabledModal.vue?vue&type=template&id=4c948abe&scoped=true&"
import script from "./CPHphCartDisabledModal.vue?vue&type=script&lang=ts&"
export * from "./CPHphCartDisabledModal.vue?vue&type=script&lang=ts&"
import style0 from "./CPHphCartDisabledModal.vue?vue&type=style&index=0&id=4c948abe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c948abe",
  null
  
)

export default component.exports